/* eslint-disable max-len */
/* eslint-disable max-lines */
/* eslint-disable max-statements */
import React from 'react';
import moment from 'moment';
import {Grid, Form, Button} from 'semantic-ui-react';
import DatePicker from 'react-datepicker';
import {monthYearFormatPicker, noTimeZoneTinyISODate} from '../../../../common/constants/datesFormat';
import {useModelInfo} from './useModelInfo';
import {BASE_DATE, pricesActions} from '../../../constants';

const Tag = ({title, content}) => {
  return <div className='vehicle-pice-color__tag'>
    <h4>{title}:&nbsp;&nbsp;</h4><span> {content}</span>
  </div>;
};

const ModelInfo = ({
  selectedVehicle,
  openHistoryPriceModal,
  updateDateMode,
  setUpdateMode,
  activeColorsList,
  selectedProduction,
  setSelectedProduction,
  setActiveColorsListCurr,
  activeColorsListDB,
  loadingPrices,
}) => {
  const {
    'actions': {
      onChangeField,
      handleSave,
      handleAddProduction,
      handleCancel,
      handleChangeProduction,
    },
    'data': {
      datesInfo,
      activeProductionsList,
      notAllowedDates,
      maxDate,
      loadingSave,
    },
  } = useModelInfo({
    selectedVehicle,
    openHistoryPriceModal,
    updateDateMode,
    setUpdateMode,
    activeColorsList,
    selectedProduction,
    setSelectedProduction,
    setActiveColorsListCurr,
    activeColorsListDB,
  });
  return (
    <>
      <Grid.Row className='no-space'>
        <Grid.Column width={1} >
          <Tag title= 'SFX' content={selectedVehicle.sfx} />
        </Grid.Column>
        <Grid.Column width={4}>
          <Tag title= 'Nombre Comercial' content={selectedVehicle.commercialName} />
        </Grid.Column>
        <Grid.Column width={3}>
          <Tag title= 'Descripción' content={selectedVehicle.description} />
        </Grid.Column>
        <Grid.Column width={8} textAlign={'right'}>
          {updateDateMode === pricesActions.read &&
            <>
              <Button
                onClick={() => openHistoryPriceModal()}
                disabled={loadingPrices}
              >
                HISTORIAL
              </Button>
              {selectedProduction &&
                <Button
                  style={{'width': 'auto'}}
                  primary
                  onClick={() => setUpdateMode(pricesActions.editDate)}
                  disabled={loadingPrices}
                >
                  EDITAR VIGENCIA
                </Button>
              }
              <>
                <Button
                  style={{'width': 'auto'}}
                  primary
                  onClick={handleAddProduction}
                  disabled={loadingPrices}
                >
                  AÑADIR PRODUCCIÓN
                </Button>
              </>
            </>
          }
          {
            !(updateDateMode === pricesActions.read) && <>
              <Button
                basic
                onClick={handleCancel}
                disabled={loadingSave || loadingPrices}
              >
                CANCELAR
              </Button>
              <Button
                loading={loadingSave}
                primary
                className='toyota-primary'
                onClick={handleSave}
                disabled={
                  loadingSave ||
                  loadingPrices ||
                  (updateDateMode === pricesActions.editDate && !activeColorsList.length)
                }
              >
                GUARDAR
              </Button>
            </>
          }
        </Grid.Column>
      </Grid.Row>
      {!(updateDateMode === pricesActions.read || updateDateMode === pricesActions.editPrices) ?
        <Grid.Row>
          <Grid.Column width={3}>
            <h4>Vigencia de producción:</h4>
          </Grid.Column>
          <Grid.Column width={1} textAlign='right'>
            <h4>Inicio:</h4>
          </Grid.Column>
          {(updateDateMode === pricesActions.addProduction) && <>
            <Grid.Column width={3}>
              <DatePicker
                placeholderText='Fecha de inicio'
                excludeDates={notAllowedDates}
                showMonthYearPicker
                selected={datesInfo.newStartDate ?
                  moment(datesInfo.newStartDate, noTimeZoneTinyISODate).toDate() :
                  null
                }
                minDate={BASE_DATE}
                customInput={<Form.Input icon='calendar' readOnly />}
                onChange={(value) => onChangeField('newStartDate', moment(value).format(noTimeZoneTinyISODate))}
                dateFormat={monthYearFormatPicker}
                locale='es'
              />
            </Grid.Column>
            <Grid.Column width={1} textAlign='right'>
              <h4>Fin:</h4>
            </Grid.Column>
            <Grid.Column width={3}>
              <DatePicker
                excludeDates={notAllowedDates}
                placeholderText='Fecha de inicio'
                showMonthYearPicker
                selected={datesInfo.newEndDate ?
                  moment(datesInfo.newEndDate, noTimeZoneTinyISODate).toDate() :
                  null
                }
                minDate={moment(datesInfo?.newStartDate, noTimeZoneTinyISODate)?.toDate()}
                maxDate={maxDate}
                customInput={<Form.Input icon='calendar' readOnly />}
                onChange={(value) => onChangeField('newEndDate', moment(value).format(noTimeZoneTinyISODate))}
                dateFormat={monthYearFormatPicker}
                locale='es'
              />
            </Grid.Column>
          </>}
          {updateDateMode === pricesActions.editDate && <>
            <Grid.Column width={3}>
              <DatePicker
                excludeDates={notAllowedDates}
                placeholderText='Fecha de inicio'
                showMonthYearPicker
                selected={datesInfo.prevStartDate ?
                  moment(datesInfo.prevStartDate, noTimeZoneTinyISODate)?.toDate() :
                  null
                }
                dateFormat={monthYearFormatPicker}
                customInput={<Form.Input icon='calendar' readOnly />}
                onChange={(value) => onChangeField('prevStartDate', moment(value).format(noTimeZoneTinyISODate))}
                locale='es'
              />
            </Grid.Column>
            <Grid.Column width={1} textAlign='right'>
              <h4>Fin:</h4>
            </Grid.Column>
            <Grid.Column width={3}>
              <DatePicker
                excludeDates={notAllowedDates}
                placeholderText='Fecha de fin'
                showMonthYearPicker
                selected={datesInfo.prevEndDate ?
                  moment(datesInfo.prevEndDate, noTimeZoneTinyISODate).toDate() :
                  null
                }
                minDate={moment(datesInfo?.prevStartDate, noTimeZoneTinyISODate)?.toDate()}
                maxDate={maxDate}
                customInput={<Form.Input icon='calendar' readOnly />}
                onChange={(value) => onChangeField('prevEndDate', moment(value).format(noTimeZoneTinyISODate))}
                dateFormat={monthYearFormatPicker}
                locale='es'
              />
            </Grid.Column>
          </>}
        </Grid.Row> :
        <Grid.Row>
          <Grid.Column width={2} textAlign='left'>
            <h4>Producción:</h4>
          </Grid.Column>
          <Grid.Column width={3}>
            <Form.Dropdown
              disabled={loadingPrices || !(updateDateMode === pricesActions.read)}
              placeholder="Seleccionar vigencia"
              fluid
              selection
              value={selectedProduction}
              onChange={(e, {value}) => handleChangeProduction(value)}
              options={activeProductionsList}
            />
          </Grid.Column>
        </Grid.Row>
      }
    </>
  );
};

export default ModelInfo;
